import {useRef} from 'react'

type AnyFunction = (...args: any[]) => any

export function useEvent<T extends AnyFunction>(callback: T): T {
  const latestRef = useRef<T>(callback)
  latestRef.current = callback

  // using useRef instead of useCallback avoids creating and empty array on every render
  const stableRef = useRef<T>(null as any)
  if (!stableRef.current) {
    stableRef.current = function (this: any, ...args) {
      return latestRef.current.apply(this, args)
    } as T
  }

  return stableRef.current
}
